export default class TapaComponent {
  constructor(name, children) {
    //Vars
    this._name = name;
    this._children = children;

    //Methods
    this.toJSON = this.toJSON.bind(this);
  }

  //Getters and Setters
  //Name
  get name() {
    return this._name;
  }
  set name(newName) {
    this._name = newName;
  }

  //Children
  get children() {
    return this._children;
  }
  set children(newChildren) {
    this._children = newChildren;
  }

  //Methods
  toJSON(namespace) {
    let jsonObject = {};

    let children = {};
    for (let i in this._children) {
      const child = this._children[i];
      if (child instanceof TapaComponent) {
        children[child.name] = this._children[i].toJSON();
      } else {
        children = child;
      }
    }

    if (!namespace) {
      jsonObject = {
        data: children
      };
    } else {
      jsonObject[this.name] = {
        data: children
      };
    }

    return jsonObject;
  }
}



// WEBPACK FOOTER //
// ./src/lib/TapaComponent.js